import React, { useEffect, useState } from "react";
import { Constants } from "@eagerdog/constants";

import { apiService } from "src/services";

import { toast } from '../Toast/ToastManager';
import { Modal, useModal } from "../Modal/Modal";
import { download, DownloadOptions } from "./DownloadManager";

export interface DownloadProps {
  files: DownloadOptions[]
}

const Download: React.FC<DownloadProps> = (props) => {
  const { isShown, toggle } = useModal();

  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const [downloadTimer, setdownloadTimer] = useState<number>(0);

  let downloadInterval: any;

  const requestDownload = (file: DownloadOptions) => { // eslint-disable-line
    switch(file.type) {
      case "event_weigh_in_forms":
        if (file.eventId) {
          apiService.requestEventWeighInForms(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "judge-scheduling-calc":
        if (file.eventId) {
          apiService.requestEventJudgeScheduleCalculator(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "catalog":
        if (file.eventId) {
          apiService.requestEventCatalog(file.eventId, file.showIds).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "registration":
        if (file.registrantId && file.dogId) {
          apiService.requestEntryForms(file.registrantId, file.dogId, false, {content: file.registrantId}).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "judge_books":
        if (file.eventId && file.showId) {
          let params: any = {};

          if (file.showElement && file.showElement !== "None") {
            params.show_element = file.showElement;
          }

          if (file.showLevel && file.showLevel !== "None") {
            params.level = file.showLevel;
          }

          if (file.showSection && file.showSection !== "None") {
            params.section = file.showSection;
          }

          // Add breed filter parameters for UKC Conformation filtering
          if (file.breed_filter_type) {
            params.breed_filter_type = file.breed_filter_type;
          }

          if (file.breed_filters && file.breed_filters.length > 0) {
            params.breed_filters = file.breed_filters;
          }

          if (file.breed_group_filters && file.breed_group_filters.length > 0) {
            params.breed_group_filters = file.breed_group_filters;
          }

          if (file.judge_books_sort) {
            params.judge_books_sort = file.judge_books_sort;
          }

          apiService.requestJudgeBooks(file.eventId, file.showId, params).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          }).catch((error) => {
            // Handle any errors from the API call
            console.error('Error requesting judge books:', error);
          });
        }
      break;
      case "judge_books_match":
        if (file.eventId && file.showId) {
          apiService.requestJudgeBooks(file.eventId, file.showId, { builder_suffix: "Match" }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          }).catch((error) => {
            console.error('Error requesting judge books:', error);
          });
        }
        break;
      case "judge_books_group":
        if (file.eventId && file.showId) {
          apiService.requestJudgeBooks(file.eventId, file.showId, { builder_suffix: "Group" }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          }).catch((error) => {
            console.error('Error requesting judge books:', error);
          });
        }
        break;
      case "judge_books_show":
        if (file.eventId && file.showId) {
          apiService.requestJudgeBooks(file.eventId, file.showId, { builder_suffix: "Show" }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          }).catch((error) => {
            console.error('Error requesting judge books:', error);
          });
        }
        break;
      case "judge_breeds":
        if (file.eventId && file.showId) {
          apiService.requestJudgeBreeds(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          }).catch((error) => {
            console.error('Error requesting judge breeds:', error);
          });
        }
        break;
      case "transaction":
        if (file.transactionId) {
          apiService.requestEntryFormsForTransaction(file.transactionId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "nwt":
        if (file.eventId && file.showType) {
          apiService.requestScoreListForShowType(file.eventId, file.showType).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "armband_labels":
        if (file.eventId) {
          apiService.requestEventArmbandLabels(file.eventId, { show_ids: file.showIds, arm_numbers: file.armNumbers }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;

      case "armband_labels_back":
        if (file.eventId) {
          apiService.requestEventArmbandLabelsBack(file.eventId, { show_ids: file.showIds, arm_numbers: file.armNumbers }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "armband_labels_5919":
        if (file.eventId) {
          apiService.requestEventArmbandLabels5919(file.eventId, { show_ids: file.showIds, arm_numbers: file.armNumbers }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "armband_labels_5919_detail":
        if (file.eventId) {
          apiService.requestEventArmbandLabels5919Detail(file.eventId, { show_ids: file.showIds, arm_numbers: file.armNumbers }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "armband_labels_5162":
        if (file.eventId) {
          apiService.requestEventArmbandLabels5162(file.eventId, { show_ids: file.showIds, arm_numbers: file.armNumbers }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "armband_labels_5919_back":
        if (file.eventId) {
          apiService.requestEventArmbandLabels5919Back(file.eventId, { show_ids: file.showIds, arm_numbers: file.armNumbers }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "armband_labels_5164":
        if (file.eventId) {
          apiService.requestEventArmbandLabels5164(file.eventId, { show_ids: file.showIds, arm_numbers: file.armNumbers }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "armband_labels_5164_back":
        if (file.eventId) {
          apiService.requestEventArmbandLabels5164Back(file.eventId, { show_ids: file.showIds, arm_numbers: file.armNumbers }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "armband_labels_3perpage":
        if (file.eventId) {
          apiService.requestEventArmbandLabels3PerPage(file.eventId, { show_ids: file.showIds, arm_numbers: file.armNumbers }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "armband_labels_4perpage":
        if (file.eventId) {
          apiService.requestEventArmbandLabels4PerPage(file.eventId, { show_ids: file.showIds, arm_numbers: file.armNumbers }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "armband":
        if (file.eventId) {
          const options = file.selectedColumns ? { selected_columns: file.selectedColumns } : undefined;
          apiService.requestRegistrationListForEvent(file.eventId, options).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "scores":
        if (file.eventId) {
          apiService.requestScoresListForEvent(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "transactions":
        if (file.eventId) {
          apiService.requestEventTransactions(file.eventId).then((response) => {
            
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "transaction_summary":
        if (file.eventId) {
          apiService.requestEventTransactionsSummary(file.eventId).then((response) => {

            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
        break;
      case "waitlists":
        if (file.eventId) {
          apiService.requestEventWaitlists(file.eventId, file.showId).then((response) => {

            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
        break;
      case "counts":
        
        if (file.eventId && file.showId) {
          apiService.requestCounts(file.eventId, file.showId).then((response) => {

            if (response._id && downloadInterval === undefined) {
              
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "counts_formatted":

        if (file.eventId && file.showId) {
          apiService.requestCountsFormatted(file.eventId, file.showId).then((response) => {

            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "print_registration":
        if (file.eventId) {
          apiService.requestEntryFormsForEvent(file.eventId, file.showTypes).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "registration_summary":
        if (file.eventId && file.userId) {
          apiService.requestRegistrationSummary(file.eventId, file.userId, file.include_waitlist).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "checkin":
        if (file.eventId && file.showId) {
          let params: any = {};

          if (file.showElement && file.showElement !== "None") {
            params.show_element = file.showElement;
          }

          if (file.showLevel && file.showLevel !== "None") {
            params.level = file.showLevel;
          }

          if (file.showSection && file.showSection !== "None") {
            params.section = file.showSection;
          }

          apiService.requestShowCheckinLists(file.eventId, file.showId, params).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "ring-sheets":
        if (file.eventId && file.showId) {
          let params: any = {};

          if (file.showElement && file.showElement !== "None") {
            params.show_element = file.showElement;
          }

          if (file.showLevel && file.showLevel !== "None") {
            params.level = file.showLevel;
          }

          if (file.showSection && file.showSection !== "None") {
            params.section = file.showSection;
          }

          if (file.builder_suffix) {
            params.builder_suffix = file.builder_suffix;
          }

          apiService.requestShowRingSheets(file.eventId, file.showId, params).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "judge_schedules":
        if (file.eventId) {
          apiService.requestJudgingSchedule(file.eventId, {
            include_breed: file.include_breed,
            include_jump_height: file.include_jump_height,
            include_call_name: file.include_call_name,
          }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "interwoven_judge_schedule":
        if (file.eventId) {
          apiService.requestInterwovenJudgingSchedule(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "judge_breeds_event":
        if (file.eventId) {
          apiService.requestEventJudgeBreeds(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "barn_hunt_results":
        if (file.eventId) {
          apiService.requestBarnHuntResults(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "fast_cat_results_detailed":
        if (file.eventId) {
          apiService.requestFastCatResultsDetailed(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "cwags_scent_results":
        if (file.eventId) {
          apiService.requestCwagsScentResults(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "run_order":
        if (file.eventId && file.showId && file.ring) {
          apiService.requestRunOrder(file.eventId, file.showId, file.ring).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "measurement_report":
        if (file.eventId && file.showId) {
          apiService.requestMeasurementReport(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "results":
        if (file.eventId && file.showId) {
          let params: any = {};

          if (file.showElement && file.showElement !== "None") {
            params.show_element = file.showElement;
          }

          if (file.showLevel && file.showLevel !== "None") {
            params.level = file.showLevel;
          }

          if (file.showSection && file.showSection !== "None") {
            params.section = file.showSection;
          }

          apiService.requestShowResultLists(file.eventId, file.showId, params).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "scoresheets":
        if (file.eventId && file.showId) {
          let params: any = {};

          if (file.showElement && file.showElement !== "None") {
            params.show_element = file.showElement;
          }

          if (file.showLevel && file.showLevel !== "None") {
            params.level = file.showLevel;
          }

          if (file.showSection && file.showSection !== "None") {
            params.section = file.showSection;
          }

          if (file.include_alternates !== undefined) {
            params.include_alternates = file.include_alternates;
          }

          const request = file.scoreId
            ? apiService.requestIndividualScoresheets(file.eventId, file.showId, file.scoreId, params)
            : apiService.requestScoresheets(file.eventId, file.showId, params);

          request.then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "akc_scoresheets":
        if (file.eventId) {
          apiService.requestEventScoresheets(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "akc_scoresheets_condensed":
        if (file.eventId) {
          apiService.requestEventScoresheetsCondensed(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "cat_scoresheet":
        if (file.eventId && file.showId) {
          apiService.requestShowScoresheet(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "fastcat_scoresheet":
        if (file.eventId && file.showId) {
          apiService.requestShowScoresheet(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "fastdash_scoresheet":
        if (file.eventId && file.showId) {
          apiService.requestShowScoresheet(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "herding_secretary_certification":
        if (file.eventId && file.showId) {
          apiService.requestShowSecretaryCertification(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "herding_high_in_trial":
        if (file.eventId && file.showId) {
          apiService.requestShowHerdingHighInTrial(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "herding_catalog":
        if (file.eventId && file.showId) {
          apiService.requestShowHerdingCatalog(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "individual_scoresheet":
        if (file.eventId && file.showId && file.scoreId) {
          apiService.requestIndividualScoresheets(file.eventId, file.showId, file.scoreId, {}).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "ukc_scoresheets":
        if (file.eventId && file.showId) {
          const params: any = { builder_suffix: file.builder_suffix };
          
          // If scoreId is provided, filter to just that one score
          if (file.scoreId) {
            params.score_id = file.scoreId;
          }
          
          const request = apiService.requestScoresheets(file.eventId, file.showId, params);

          request.then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "ribbons":
        if (file.eventId && file.showId && (file.labelsToSkip !== undefined)) {
          let params: any = {
            labels_to_skip: file.labelsToSkip
          };

          if (file.showElement && file.showElement !== "None") {
            params.show_element = file.showElement;
          }

          if (file.showLevel && file.showLevel !== "None") {
            params.level = file.showLevel;
          }

          if (file.showSection && file.showSection !== "None") {
            params.section = file.showSection;
          }

          if (file.small !== undefined) {
            params.small = file.small;
          }

          if (file.format_5162 !== undefined) {
            params.format_5162 = file.format_5162;
          }

          apiService.requestResultRibbonLabels(file.eventId, file.showId, params).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "scoresheet-labels":
        if (file.eventId && file.showId && (file.labelsToSkip !== undefined)) {
          let params: any = {
            labels_to_skip: file.labelsToSkip
          };

          if (file.showElement && file.showElement !== "None") {
            params.show_element = file.showElement;
          }

          if (file.showLevel && file.showLevel !== "None") {
            params.level = file.showLevel;
          }

          if (file.showSection && file.showSection !== "None") {
            params.section = file.showSection;
          }

          apiService.requestScoresheetLabels(file.eventId, file.showId, params).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "junioir_participation_report":
        if (file.eventId && file.showId) {
          apiService.requestJuniorParticipationReport(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          })
        }
      break;
      case "trial":
        if (file.eventId && file.showId) {
          apiService.requestTrialReport(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          })
        }
      break;
      case "hit_trial":
        if (file.eventId && file.showId) {
          apiService.requestHighInTrialReport(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          })
        }
        break;
      case "championship_points":
        if (file.eventId && file.showId) {
          apiService.requestChampionshipPointsReport(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          })
        }
        break;
      case "junior_handler_certificate":
        if (file.eventId && file.showId) {
          apiService.requestJuniorHandlerCertificate(file.eventId, file.showId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          })
        }
        break;
      case "ukc_total_dog_report":
        if (file.eventId) {
          apiService.requestUkcTotalDogReport(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "ukc_event_counts":
      case "ukc_event_counts_formatted":
        if (file.eventId) {
          apiService.requestUkcEventCounts(file.eventId, { condensed_conformation: file.type === "ukc_event_counts_formatted" }).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "akc_udx_combined_list":
        if (file.eventId) {
          apiService.requestAkcUdxCombinedList(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "akc_results":
        if (file.eventId) {
          apiService.requestAkcResultsXml(file.eventId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "club_contacts":
        if (file.clubId) {
          apiService.requestClubContactsExport(file.clubId, file.capacityFilters).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "club_store_transactions":
        if (file.clubId) {
          apiService.requestClubStoreTransactionsExport(file.clubId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
      case "course_roster":
        if (file.courseId) {
          apiService.requestCourseSessionRosterExport(file.courseId).then((response) => {
            if (response._id && downloadInterval === undefined) {
              downloadInterval = setInterval(() => { checkCurrentDownload(response) }, 1000);
            }
          });
        }
      break;
    }
  }

  const checkCurrentDownload = (current: any) => {
    apiService.getFormStatus(current._id).then((status) => {
      if (!status) {
        setdownloadTimer(downloadTimer + 1);
        return;
      }
      if (status.status === Constants.form_build_status.complete) {
        apiService.downloadForm(current._id);
        setIsDownloading(false);
        download.shiftDownload();
        setdownloadTimer(0);

        clearInterval(downloadInterval);
        downloadInterval = undefined;
      } else if (status.status === Constants.form_build_status.error) {
        toast.show({
          title: "Download",
          content: "Unable to start download. (" + status.message + ")",
          duration: 10000,
          type: "fail"
        });

        setIsDownloading(false);
        download.shiftDownload();
        setdownloadTimer(0);

        clearInterval(downloadInterval);
        downloadInterval = undefined;
      } else {
        setdownloadTimer(downloadTimer + 1);
      }
    }).catch(() => {
      setdownloadTimer(downloadTimer + 1);
    });
  }

  useEffect(() => {
    if (props.files.length > 0 && !isDownloading) {
      if (!isShown) {
        toggle();
      }

      setIsDownloading(true);
      requestDownload(props.files[0]);
    } else if (props.files.length === 0 && !isDownloading && isShown) {
      toggle();
    }
  }, [isShown, props.files, toggle, isDownloading, requestDownload]);

  const getDownloadContent = () => {
    return(
      <div className="downloadWrap">
        <div className="title">Downloading Files</div>
        <div className="content">
          <div id="loading"></div>
          <div className="message">
            <span>Generating Files ({props.files.length} in queue)</span>
            {downloadTimer >= 5 && <span className="largeDownload">This is taking a while, you can close this window and your browser will start the download when it's ready.</span>}
          </div>
        </div>
      </div>
      );
  }

  return (<Modal className="Download" isShown={isShown} hide={toggle} modalContent={getDownloadContent()}  />);
};

export default Download;